import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

/**
 * Functional auth guard — checks backend session on every protected route.
 *
 * If no valid session exists, redirects to the backend login endpoint.
 * The backend handles the full OIDC flow including retries:
 *   /login → Keycloak → /callback → dashboard (success)
 *   /login → Keycloak → /callback → /login (failure, fresh retry)
 *
 * Keycloak handles user-facing errors (wrong password, locked account) natively.
 */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  return auth.checkSession().pipe(
    take(1),
    map((session) => {
      if (session) {
        return true;
      }
      // No session — redirect to backend login
      auth.login();
      return false;
    }),
  );
};
